import { axios } from "./http.js";

export const addExpCenter = params => {
  return axios.post("/exp_center/", params);
};
// 按分类分页查询展厅列表, 分类：0=国际展厅，1=国内展厅
export const getExpCenterPageList = params =>
  axios.get(
    `/exp_center/page/${params.type}/${params.pageNo}/${params.pageSize}`
  );

export const getExpCenterTypeList = params =>
  axios.get(`/exp_center/list/${params.type}`);

export const deleteExpCenter = id => {
  return axios.delete(`/exp_center/${id}`);
};

export const putExpCenter = params => {
  return axios.put(`/exp_center/${params.id}`, params);
};
export const getExpCenter = id => axios.get(`/exp_center/${id}`);
